var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-invitee-list-no-email-configured-message" },
    [
      _c(
        "div",
        {
          staticClass: "editor-invitee-list-no-email-configured-message__icon"
        },
        [_vm._v("\n\t\t@\n\t")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "editor-invitee-list-no-email-configured-message__caption",
        domProps: { innerHTML: _vm._s(_vm.htmlCaption) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }